/* eslint-disable max-statements */
import React, { DependencyList, useEffect, useRef, useState } from 'react';
import ReactCrop, {
	Crop,
	PixelCrop,
	centerCrop,
	makeAspectCrop
} from 'react-image-crop';
import { imgPreview } from './imgPreview';
import { useTypedSelector } from '../../../../../hooks/useTypeSelector';
import { useDispatch } from 'react-redux';
import { AspectRatiosEnum } from '../editImage';
import {
	setNewStandardCrop,
	setNewStandardCroppedImagePreveiw,
	setOldStandardCrop,
	setOldStandardCroppedImagePreveiw,
	setPortraitCrop,
	setPortraitCroppedImagePreveiw,
	setWideCrop,
	setWideCroppedImagePreveiw
} from '../../../../../redux/actions/cropAction';

export const CroppableImagePreview = ({
	originalImage,
	setIsImageModalPreviewOpen,
	setIsChanged
}: {
	originalImage: string;
	setIsImageModalPreviewOpen: (isModalOpen: boolean) => void;
	setIsChanged: (isChanged: boolean) => void;
}) => {
	const {
		oldStandardCrop,
		newStandardCrop,
		portraitCrop,
		wideCrop,
		selectedCropARType
	} = useTypedSelector((state) => state.crop);

	const [crop, setCrop] = useState<Crop>();
	const [completedCrop, setCompletedCrop] = useState<PixelCrop>();
	const [scale] = useState(1);
	const [rotate] = useState(0);
	const [hasError, setHasError] = useState(false);
	const [croppedImage, setCroppedImage] = useState<string>();
	const [cropData] = useState<Crop>(
		selectedCropARType === AspectRatiosEnum.NEW_STANDARD
			? newStandardCrop
			: selectedCropARType === AspectRatiosEnum.WIDE
			? wideCrop
			: selectedCropARType === AspectRatiosEnum.OLD_STANDARD
			? oldStandardCrop
			: portraitCrop
	);

	const { newStandardCroppedImagePreview } = useTypedSelector(
		(state) => state.crop
	);

	const dispatch = useDispatch();

	const setCropData =
		selectedCropARType === AspectRatiosEnum.NEW_STANDARD
			? setNewStandardCrop
			: selectedCropARType === AspectRatiosEnum.WIDE
			? setWideCrop
			: selectedCropARType === AspectRatiosEnum.OLD_STANDARD
			? setOldStandardCrop
			: setPortraitCrop;

	// const setAspectRatioCropImage =
	// 	selectedCropARType === AspectRatiosEnum.NEW_STANDARD
	// 		? setNewStandardCroppedImagePreveiw
	// 		: selectedCropARType === AspectRatiosEnum.WIDE
	// 		? setWideCroppedImagePreveiw
	// 		: selectedCropARType === AspectRatiosEnum.OLD_STANDARD
	// 		? setOldStandardCroppedImagePreveiw
	// 		: setPortraitCroppedImagePreveiw;

	useEffect(() => {
		if (crop != null) dispatch(setCropData(crop));
	}, [crop]);

	function onImageLoad(e: React.SyntheticEvent<HTMLImageElement>) {
		const image = e.currentTarget;
		if (cropData) setCrop(cropData);
		else if (selectedCropARType) {
			const { width, height } = image;
			setCrop(
				centerCrop(
					makeAspectCrop(
						{
							unit: '%',
							width: 60
						},
						selectedCropARType,
						width,
						height
					),
					width,
					height
				)
			);
		}
	}

	function useDebounceEffect(
		fn: (deps: DependencyList) => void,
		waitTime: number,
		deps: DependencyList
	) {
		useEffect(() => {
			const t = setTimeout(() => {
				fn.apply(undefined, [deps]);
			}, waitTime);

			return () => {
				clearTimeout(t);
			};
		}, deps);
	}

	useDebounceEffect(
		async () => {
			console.log(newStandardCroppedImagePreview);
			if (completedCrop?.width && completedCrop?.height) {
				imgPreview(
					newStandardCroppedImagePreview,
					setCroppedImage,
					completedCrop,
					scale,
					rotate
				);
			}
		},
		100,
		[completedCrop, scale, rotate]
	);

	useEffect(() => {
		if (croppedImage != null) {
			const image = new Image();
			image.src = croppedImage;

			if (selectedCropARType === AspectRatiosEnum.NEW_STANDARD) {
				setNewStandardCroppedImagePreveiw(image);
			} else if (selectedCropARType === AspectRatiosEnum.WIDE) {
				setWideCroppedImagePreveiw(image);
			} else if (selectedCropARType === AspectRatiosEnum.OLD_STANDARD) {
				setOldStandardCroppedImagePreveiw(image);
			} else {
				setPortraitCroppedImagePreveiw(image);
			}
		}
	}, [croppedImage]);

	return (
		<div
			className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 
					  h-full md:h-auto ml-8 px-4 py-2 max-h-[80%] mt-10 flex flex-col w-full"
		>
			<section className="relative max-h-screen overflow-y-auto bg-transparent mx-auto">
				<div className="mx-auto w-full flex justify-center my-3">
					<div className="w-8/12 flex flex-col space-y-3">
						<div>
							<button
								className="btn btn-outline btn-sm mr-5 "
								type="button"
								style={{ transition: 'all .15s ease' }}
								onClick={() => setIsImageModalPreviewOpen(false)}
							>
								Cancel
							</button>
							<button
								className="btn btn-outline btn-primary btn-sm mr-5 "
								type="button"
								style={{ transition: 'all .15s ease' }}
								onClick={() => {
									setIsChanged(true);
									setIsImageModalPreviewOpen(false);
								}}
							>
								save crop
							</button>
						</div>
						<ReactCrop
							crop={crop}
							onChange={(_, percentCrop) => setCrop(percentCrop)}
							onComplete={(c) => {
								setCompletedCrop(c);
								setCrop(c);
							}}
							aspect={selectedCropARType}
						>
							<img
								alt="Crop me"
								className="rounded-lg block object-cover object-center mx-auto"
								src={originalImage}
								onLoad={onImageLoad}
								style={{ transform: `scale(${scale}) rotate(${rotate}deg)` }}
								crossOrigin={hasError ? undefined : 'anonymous'}
								onError={() => setHasError(true)}
							/>
						</ReactCrop>
					</div>
				</div>
			</section>
		</div>
	);
};

export const FullScreenImagePreview = ({
	image,
	aspect,
	setIsImageModalPreviewOpen
}: {
	image: string;
	aspect: string;
	setIsImageModalPreviewOpen: (isModalOpen: boolean) => void;
}) => {
	return (
		<div
			className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 
					  h-full md:h-auto ml-8 px-4 py-2 max-h-[90%] mt-10 flex flex-col w-full"
		>
			<section className="relative max-h-screen overflow-y-auto bg-transparent mx-auto">
				<img
					className={`max-h-[80vh] mx-auto rounded-lg block object-cover object-center ${aspect} w-full`}
					src={image}
				/>
			</section>
		</div>
	);
};
